module.exports = __webpack_public_path__ + "static/Secure 3-faaea4e0e7b2bbb050bdc4956dc5e6e4.png";